import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 4h-10v16","key":"svg-0"}],["path",{"d":"M7 12l8 0","key":"svg-1"}]]

const IconLetterF = createReactComponent('outline', 'letter-f', 'LetterF', __iconNode);

export default IconLetterF;